import { get } from '@bigyouth/base'
import withScroll from '../hoc/withScroll'
import onResize from '../utils/onResize'

export default withScroll({
  name: 'training-nav',

  ui: {
    'sections[]': '[js-training-nav-section]',
    'links[]': '[js-training-nav-link]',
    current: '[js-training-nav-current]',
    currentTxt: '[js-training-nav-current-txt]',
    nav: '[js-training-nav-nav]',
    summary: '[js-training-nav-summary]',
    sticky: '[js-training-nav-sticky]',
  },

  offset: window.innerWidth >= 1024 ? 0 : 87, // height of summary - 1 px
  lastSection: null,

  events: [
    {
      target: 'links',
      on: 'click',
      handle (e) {
        e.preventDefault()
        const offsetTop = this.getOffsetTop(get(e.target.dataset.target))
        window.scrollTo({ top: offsetTop - this.offset, behavior: 'smooth' })

        this.ui.nav.classList.remove('is-active')
        this.ui.current.classList.remove('is-active')
      },
    },
    {
      target: 'current',
      on: 'click',
      handle (e) {
        this.ui.nav.classList.toggle('is-active')
        this.ui.current.classList.toggle('is-active')
      },
    },
  ],

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    this.lastSection = this.ui.sections[this.ui.sections.length - 1]
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.offset = window.innerWidth >= 1024 ? 0 : 87 // height of summary - 1 px
  },

  getOffsetTop (el) {
    if (!el) return 0
    return this.getOffsetTop(el.offsetParent) + el.offsetTop
  },

  onScroll ({ y }) {
    this.ui.sections.forEach((section) => {
      const offsetTop = this.getOffsetTop(section)
      const link = get(`.training-summary__link[href="#${section.id}"]`)

      if (
        y >= offsetTop - this.offset &&
        y < offsetTop + section.offsetHeight
      ) {
        link.classList.add('is-active')
        link.parentNode.classList.add('is-active')

        this.ui.currentTxt.innerHTML = get('h2', section).textContent
      } else {
        link.classList.remove('is-active')
        link.parentNode.classList.remove('is-active')
      }
    })

    // mobile display
    if (
      y > this.getOffsetTop(this.ui.sections[0]) &&
      y < this.getOffsetTop(this.lastSection) + this.lastSection.offsetHeight
    ) {
      this.ui.summary.classList.add('is-active')
      this.ui.sticky.classList.add('is-active')
    } else {
      this.ui.summary.classList.remove('is-active')
      this.ui.sticky.classList.remove('is-active')
    }
  },
})
